import { defineQuery } from 'next-sanity'
import { imageFields, inlineCtaFields } from '../atoms'

export const careersTextImageBlockFields = `
  _id,
  _type,
  heading,
  mainText,
  buttonLink {
    ${inlineCtaFields}
  },
  image {
    ${imageFields}
  },
  imagePosition,
  decorativeShape
`

export const CAREERS_TEXT_IMAGE_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-text-image-block"][0]{
    ${careersTextImageBlockFields}
  }
`)
